import { render, staticRenderFns } from "./agentDetail.vue?vue&type=template&id=dabb65fc&scoped=true"
import script from "./agentDetail.vue?vue&type=script&lang=js"
export * from "./agentDetail.vue?vue&type=script&lang=js"
import style0 from "./agentDetail.vue?vue&type=style&index=0&id=dabb65fc&prod&lang=css"
import style1 from "./agentDetail.vue?vue&type=style&index=1&id=dabb65fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dabb65fc",
  null
  
)

export default component.exports